import restUrls from "web/constants/restUrls";

import api from "../api/apiSlice";

export enum ObjectRelation {
  HAS_PERMISSION = "HAS_PERMISSION",
  HAS_ROLE = "HAS_ROLE",
  IS_MEMBER = "IS_MEMBER",
  MANAGES_ALL_EMPLOYEE_GROUPS = "MANAGES_ALL_EMPLOYEE_GROUPS",
  MANAGES_ALL_ORGANIZATION_UNITS = "MANAGES_ALL_ORGANIZATION_UNITS",
  MANAGES = "MANAGES",
  HAS_FUNCTIONALITY = "HAS_FUNCTIONALITY",
  IS_SUBORDINATE = "IS_SUBORDINATE",
  IS_ENABLED = "IS_ENABLED",
  HAS_ACCESS = "HAS_ACCESS",
}

export enum ObjectType {
  MODULE = "MODULE",
}

interface IPermissions {
  objectType: ObjectType;
  objectId: string;
  objectRelation: ObjectRelation;
}

export const permissionsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserPermissions: builder.query<IPermissions[], void>({
      query: () => restUrls.permissions,
      providesTags: ["Permissions"],
    }),
  }),
});

export const { useLazyGetUserPermissionsQuery } = permissionsApiSlice;
